export default __webpack_public_path__ + "scene02ea81a8.jpg";